import { eventHeightMap } from '@cont/PlannerV2/planner-constants';
import BaseCard from '@cont/PlannerV2/PlannerCards/BaseCard';
import pushRoute from '@utils/pushRoute';
import TestHeroIcon from './TestHeroIcon';
import { PlannerItemWrapper } from '../PlannerElements';

const TestCard = ({ metaItem }) => {
  const {
    name,
    author,
    activityAt,
    eventType,
    isLive,
    isCancelled,
    isUpcoming,
    hasWatched,
    relativeLink,
    showIcon,
    iconColor,
    info,
    showVenue,
    venueName
  } = metaItem;
  const isClickable = !isUpcoming && !isCancelled;
  const handleItemClick = () => {
    if (!isClickable) return;
    pushRoute('/quiz/[quizSlug]/[quizUID]', relativeLink);
  };
  const showMenu = !(isLive || isCancelled);
  return (
    <PlannerItemWrapper $height={eventHeightMap[eventType]}>
      <BaseCard
        title="Test"
        tooltipTitle="View Test"
        titleColor="var(--color-i-test)"
        description={name}
        info={info}
        isLive={isLive}
        isCancelled={isCancelled}
        isUpcoming={isUpcoming}
        isClickable={isClickable}
        hasCompleted={hasWatched}
        author={author}
        activityAt={activityAt}
        item={metaItem}
        showMenu={showMenu}
        rightIcon={
          showIcon ? <TestHeroIcon color={iconColor} isLive={isLive} /> : null
        }
        onItemClick={handleItemClick}
        showVenue={showVenue}
        venueName={venueName}
      />
    </PlannerItemWrapper>
  );
};

export default TestCard;
